import { get } from "../modules/env";
import { fetchWithRetry } from "../utils/network";

export interface CurrentUser {
  publicUserId: string;
  avatar: {
    image: string | null;
  } | null;
}

/**
 * Returns the current user's info.
 */
export async function getCurrentUser(): Promise<CurrentUser | null> {
  const url = get("USER_API_URL") ?? globalThis.document.location.origin;

  return fetch(url, {
    credentials: "include",
  }).then(async (x) => await x.json());
}

/**
 * Adds the provided email address to a newsletter
 * distribution.
 */
export async function subscribeToNewsletter(email: string, types: string[]) {
  const url = get("NEWSLETTER_API_URL");

  if (!url) {
    throw new Error("NEWSLETTER_API_URL is not set");
  }

  const formData = new FormData();
  formData.append("email", email);
  formData.append("type", types.join(","));

  const response = await fetchWithRetry(url, {
    method: "POST",
    body: formData,
    headers: {
      "X-BibleProject-Language": get("LANGUAGE") ?? "en",
    },
  });

  return response.ok;
}
